import * as action from 'actions'
import * as apiSetting from 'api/settings'
import {call, put} from 'redux-saga/effects'
import * as actNotif from 'actions/notifications'

export function * putUpdateSetting (data) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())
  try {
    let response = yield call(apiSetting.putUpdateSetting, data)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.sendingRequest(false))
    yield put(action.hideProgressBar())
  }
}



// WEBPACK FOOTER //
// ./app/sagas/api/settings.js